import {createFsCockpitAuthedAxiosInstance} from "./axiosFsCockpitAuthAdapter";

const wineAppBaseUrl = process.env.REACT_APP_WINE_APP_BACKEND_BASE_URL;
const wineAppClient = createFsCockpitAuthedAxiosInstance({
    baseURL: wineAppBaseUrl
});

export interface AlgoliaCredentials {
    appId: string
    apiKey: string
    productIndex: string
}

export function getAlgoliaCredentials(): Promise<AlgoliaCredentials> {
    return wineAppClient.request({
        method: 'GET',
        url: '/config/algolia',
        responseType: 'json'
    }).then(response => response.data as AlgoliaCredentials);
}

export interface FrequentlyBoughtWinesRequest {
    soldTo: string
}

export interface FrequentlyBoughtWine {
    id: string
}

export type FrequentlyBoughtWinesResponse = FrequentlyBoughtWine[]

export function fetchFrequentlyBoughtWines(request: FrequentlyBoughtWinesRequest): Promise<FrequentlyBoughtWinesResponse> {
    return wineAppClient.request({
        method: 'GET',
        url: `/favoredwines/frequentlybought/${request.soldTo}/`,
        responseType: 'json'
    }).then(response => response.data as FrequentlyBoughtWinesResponse);
}

export interface CustomerAddressData {
    name: string
    street: string
    postalCode: string
    city: string
}

export function fetchCustomerAddressData(soldTo: string): Promise<CustomerAddressData> {
    return wineAppClient.request({
        method: 'GET',
        url: `/customer/${soldTo}/address/`,
        responseType: 'json'
    }).then(response => response.data as CustomerAddressData);
}

export const wineAppApi  = {
    getAlgoliaCredentials,
    fetchFrequentlyBoughtWines
}